module.exports = __webpack_public_path__ + "static/media/apartment9.9c1b76be.png";